import React from 'react';
import { LinearProgress } from 'material-ui/Progress';
import {
    Button,
    Grid,
    Paper,
    Typography,
    withStyles
} from 'material-ui';
import {
    getReservationById,
    cancelReservationById
} from './../Reservations/reservationsServices';
import ReservationStatusRender from './ReservationStatusRender';
import ReservationDetailsRender from './ReservationDetailsRender';
import ReservationPricesRender from './ReservationPricesRender';
import HotelHeaderRender from './HotelHeaderRender';
import OLYWebPageComponent from '../OLYWebPageComponent';
import CancelIcon from 'material-ui-icons/Cancel';
import AlertIcon from 'material-ui-icons/Error';
import BackIcon from 'material-ui-icons/KeyboardArrowLeft';
import CheckIcon from 'material-ui-icons/Check';
import classNames from 'classnames';
import { netPrice } from '../../defaultValues/netPrice';
import getValue from '../../defaultValues/getValue';
import { translate } from 'react-i18next';
import TransferDetailRender from '../Transfers/TransferDetailRender';
import ReservationBigButton from './ReservationBigButton';
import ReservationCancelDetailsRender from './ReservationCancelDetailsRender';
import swal from 'sweetalert';
import DynIcon from '../Utils/DynIcon';

const styles = theme => ({
    column: {
        flexBasis: '33.33%',
    },
    columnall: {
        flexBasis: '77.77%',
    },
    onRequestMessageBox: {
        fontSize: '18px',
        fontWeight: 300,
        marginBottom: '24px',
        marginTop: '8px',
        color: theme.palette.primary.contrastText
    },
    locatorTitle: {
        color: theme.palette.primary.contrastText,
        fontSize: '16px',
        fontWeight: 300,
    },
    expansionPanelFilter: {
        backgroundColor: theme.palette.primary.main,
    },
    onRequestIcon: {
        color: theme.palette.primary.contrastText,
        transform: 'scale(1.6)',
        float: 'left',
        marginRight: '16px',
        marginTop: '8px'
    },
    error: {
        backgroundColor: theme.palette.background.error
    },
    success: {
        backgroundColor: theme.palette.background.success
    }
});




/**
 * Title: Cancelacion de reserva.
 * Help: https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/634978311/UI+-+Cancelacion+Reserva
 */
class ReservationCancelView extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        //Para futuro tracking y ademas para tener un navigation correcto.
        this.pageName = 'ReservationCancelView';
        this.pageReference =
            'https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/634978311/UI+-+Cancelacion+Reserva';

        let idReserva = '';
        this.state = {
            idReserva: idReserva,
            loading: true,
            quierocancelar: false,
            reservation: null,
            info: props.t('BOOKING_DETAIL.ACCESSING_BOOKING_DETAIL'),
            operationstatus: 'error',
            operationtitle: props.t('CANCEL_BOOKING.CANCEL_BOOKING_USER_WARN'),
            operationtext: props.t('CANCEL_BOOKING.CANCEL_BOOKING_USER_WARN'),
            B2bVerPVP: JSON.parse(localStorage.getItem('user')).authorities.includes('B2bVerPVP')
        };
        window.scrollTo(0, 0);
    }

    pageTitleParts() {
        let parts = super.pageTitleParts();
        parts.push(this.requestCode);
        return parts;
    }

    onHashChanged = hashObject => {
        //este hash responde a /misreservas/U18X000066X02/cancelar
        if (hashObject && hashObject.parts && hashObject.parts.length > 1) {
            let requestCode = hashObject.parts[1];
            let fichaopen = hashObject.parts.includes('fichaopen');
            if (requestCode) {
                this.requestCode = requestCode;
                //tengo que pedir el objeto RESERVA al API
                this.setState(
                    {
                        expanded: fichaopen,
                        idReserva: requestCode,
                    },
                    () => {
                        this.getReservation();
                    },
                );
            }
        }
    };

    handleCancelSubmit = async (event) => {
        let allowcancel = this.displayCancel(this.state.reservation);
        if (!allowcancel) {
            alert(this.props.t('CANCEL_BOOKING.CANCEL_BOOKING_USER_ERROR'));
            return;
        }
        let response = await swal({
            title: this.props.t('CANCEL_BOOKING.CANCEL_BOOKING_BUTTON'),
            text: this.props.t('CANCEL_BOOKING.CANCEL_BOOKING_USER_QUESTION'),
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        });
        if (!response) {
            return;
        }

        window.scrollTo(0, 0);
        this.setState({
            loading: true,
            info: this.props.t('CANCEL_BOOKING.CANCEL_BOOKING_PROCESSING') + ' ...',
        });
        let reserva = this.state.reservation;
        cancelReservationById(reserva)
            .then(data => {
                if (data.paymentsCancelationsResults && data.paymentsCancelationsResults.error) {
                    alert(data.paymentsCancelationsResults.error.message);
                }
                //200 - cancelo con exito
                //500 - entonces error
                let reservation = this.state.reservation;
                reservation.state = 'C';
                this.setState({
                    loading: false,
                    reservation: reservation,
                    operationstatus: 'success',
                    operationtitle: this.props.t('CANCEL_BOOKING.CANCEL_BOOKING_SUCCESS'),
                    operationtext: null,
                });
                this.openReservationFromServer();
            })
            .catch(e => {
                alert(e.message);
                this.handleRequestError(e);
            });
    };

    handleRequestError = error => {
        this.setState({
            loading: false,
            operationstatus: 'error',
            operationtitle: this.props.t('CANCEL_BOOKING.CANCEL_BOOKING_ERROR'),
            operationtext: error.message,
        });
    };

    displayCancel(reservation) {
        return reservation && reservation.allowedActions ? reservation.allowedActions.includes('CANCEL') : false;
    }

    getReservation = () => {
        this.setState({ loading: true });
        const reservationdata = JSON.parse(localStorage.getItem('reservationToCancel'));

        if (!reservationdata) {
            this.openReservationFromServer();
        }
        else {
            if (reservationdata && reservationdata.message) {
                this.setState({
                    loading: false,
                    reservation: null,
                    operationstatus: 'error',
                    operationtitle: reservationdata.message,
                    operationtext: null,
                    observations: null,
                });
            }
            else {
                const reservation = reservationdata.reservation;
                const allowcancel = this.displayCancel(reservation);
                if (allowcancel) {
                    this.setState({
                        loading: false,
                        reservation: reservation,
                        info: this.props.t('BOOKING_DETAIL.ACCESSING_BOOKING_DETAIL'),
                        operationstatus: 'error',
                        operationtitle: this.props.t('CANCEL_BOOKING.CANCEL_BOOKING_USER_WARN'),
                        operationtext: this.props.t('CANCEL_BOOKING.CANCEL_BOOKING_TEXT'),
                    });
                } else {
                    this.setState({
                        loading: false,
                        reservation: reservation,
                        operationstatus: 'error',
                        operationtitle: this.props.t('CANCEL_BOOKING.CANCEL'),
                        operationtext: this.props.t('CANCEL_BOOKING.CANCEL_BOOKING_USER_ERROR'),
                    });
                }
            }
            localStorage.removeItem('reservationToCancel');
            this.setState({ loading: false });
        }

    }


    openReservationFromServer = async (event) => {
        this.setState({ loading: true });
        try {
            const reservation = await getReservationById(this.state.idReserva);
            let allowcancel = this.displayCancel(reservation);
            if (allowcancel) {
                this.setState({
                    loading: false,
                    reservation: reservation,
                    info: this.props.t('BOOKING_DETAIL.ACCESSING_BOOKING_DETAIL'),
                    operationstatus: 'error',
                    operationtitle: this.props.t('CANCEL_BOOKING.CANCEL_BOOKING_USER_WARN'),
                    operationtext: this.props.t('CANCEL_BOOKING.CANCEL_BOOKING_TEXT'),
                });
            } else {
                this.setState({
                    loading: false,
                    reservation: reservation,
                    operationstatus: 'error',
                    operationtitle: this.props.t('CANCEL_BOOKING.CANCEL'),
                    operationtext: this.props.t('CANCEL_BOOKING.CANCEL_BOOKING_USER_ERROR'),
                });
            }
        } catch (error) {
            this.setState({
                loading: false,
                reservation: null,
                operationstatus: 'error',
                operationtitle: this.props.t('CANCEL_BOOKING.CANCEL'),
                operationtext: error.message,
            });
            alert(error.message);
        }
        finally {
            this.setState({ loading: false });
        }
    };

    reservationIsCancelled = () => {
        return this.state.reservation && this.state.reservation.state === 'C';
    };

    getClass() {
        const { classes } = this.props;
        return this.reservationIsCancelled() ? classes.success : classes.error;
    }

    disableCancelButton = () => {
        return !this.state.quierocancelar || this.state.loading;
    }

    renderTabButton = (reservation) => {
        return (
            <div>
                <div className="cmsCancelTransferTab">
                    {reservation ?
                        <ReservationBigButton reservation={reservation} t={this.props.t} /> : ''
                    }
                </div>
                <TransferDetailRender currentUser={this.currentUser} reservation={reservation} transfer={reservation.transfer} displayPrice={true} viewOnlyMode={true} />
            </div>
        );
    }

    render() {
        const { classes, t } = this.props;
        const reservation = this.state.reservation;
        const { cancellationInsurance } = reservation && reservation.hotel ? reservation.hotel : {};
        return (
            <div className="cmsCancellation">
                <div className="cmsContainer">
                    <div>
                        {this.state.loading ? (
                            <div>
                                <div className="cmsContainer">
                                    {this.state.info}
                                    <LinearProgress className="cmsProgressBar" />
                                </div>
                            </div>
                        ) : ''}
                        {/*
                        RESERVATION CANCELLATION MESSAGE
                    */}
                        {
                            <div className={classNames(this.getClass(), 'InformationPanel')}>
                                <div>
                                    <Grid container>
                                        {
                                            this.reservationIsCancelled() ?
                                                <Grid item xs>
                                                    <CheckIcon className={classes.onRequestIcon} />
                                                    <Typography
                                                        className={classes.onRequestMessageBox}>
                                                        {t('CANCEL_BOOKING.CANCEL_BOOKING_SUCCESS_2')}
                                                    </Typography>
                                                </Grid>
                                                :
                                                <Grid item xs>
                                                    <AlertIcon className={classes.onRequestIcon} />
                                                    <Typography
                                                        className={classes.onRequestMessageBox}>
                                                        {this.state.operationtext}
                                                    </Typography>
                                                </Grid>
                                        }
                                    </Grid>
                                </div>
                            </div>
                        }
                        <div className="cmsStatus">
                            <div className={classes.expansionPanelFilter}>
                                <ReservationStatusRender reservation={this.state.reservation} message={t('MODIFY_BOOKING.BOOKING_STATE') + ': '} />
                                <div>
                                    <Typography className={classes.locatorTitle}>
                                        {t('CANCEL_BOOKING.LOCATOR') + ': '}
                                        <span>
                                            {this.state.idReserva}
                                            {cancellationInsurance && cancellationInsurance.active === 'SI' &&
                                                <span>
                                                    {t('BOOKINGS.CANCELLATION_INSURANCE_INCLUDED')}
                                                    <a href="../../../assets/Clausulas SEGURO ANULACION_ESP.pdf" target='_blank'>
                                                        {t('BOOKINGS.SHOW_CONDITIONS')}
                                                    </a>
                                                </span>
                                            }
                                        </span>
                                    </Typography>
                                </div>
                            </div>
                        </div>
                        <Grid container justify={'space-between'} alignItems={'stretch'}>
                            <Grid item xs={12}>
                                <div className="cmsRepeat" style={{ backgroundColor: 'grey' }}>
                                    {reservation ?
                                        <ReservationBigButton reservation={reservation} t={this.props.t} /> : ''
                                    }
                                </div>
                                <Paper>
                                    {(reservation && reservation.type === 'Hotel') ?
                                        <HotelHeaderRender expanded={this.state.expanded} hotel={reservation.hotel} />
                                        : ''
                                    }
                                    {(reservation && reservation.type === 'DirectionsBus') ?
                                        <TransferDetailRender
                                            currentUser={this.currentUser}
                                            transfer={reservation.transfer}
                                            reservation={reservation}
                                            viewOnlyMode={true}
                                            displayPrice={true} /> : ''
                                    }
                                </Paper>
                            </Grid>
                            <Grid item xs={12} className="cmsReservationData">
                                {(reservation && reservation.type === 'Hotel') ?
                                    <ReservationDetailsRender reservation={reservation} cancellationInsurance={cancellationInsurance} displayprice={true} />

                                    : ''}


                                <div>
                                    {
                                        this.state.reservation ?
                                            this.state.reservation.associatedTransfers.map(item => {
                                                return this.renderTabButton(item);
                                            })
                                            : ''
                                    }
                                </div>
                                {reservation && reservation.hotel &&
                                    <ReservationPricesRender
                                        reservation={reservation}
                                        cancellationInsurance={reservation.hotel.cancellationInsurance}
                                        displayToolTip={this.accountName == 'b2bweberoski'}
                                        onlyShowPVP={!getValue(netPrice, this.accountName)}
                                    />
                                }

                                <ReservationCancelDetailsRender
                                    onCheck={(data) => {
                                        //alert(data);
                                        this.setState({ quierocancelar: data });
                                    }}
                                    reservation={reservation} viewOnlyMode={false} />
                                <Grid container item xs={12}>
                                    <Grid item xs={6}>
                                        <div>
                                            {
                                                reservation !== null && reservation.state !== 'C' ?
                                                    (
                                                        < Button variant="flat"
                                                            color="primary"
                                                            onClick={() => {
                                                                window.location.href = window.location.href.replace('cancel', 'view');
                                                                return false;
                                                            }}
                                                            disabled={this.state.loading}>
                                                            <BackIcon />
                                                            <Typography variant="button" noWrap={true}>
                                                                {t('CANCEL_BOOKING.CANCEL_AND_BACK_BUTTON')}
                                                            </Typography>
                                                        </Button>
                                                    ) : (
                                                        < Button variant="flat"
                                                            color="primary"
                                                            onClick={() => {
                                                                window.location.href = '#/search/hotels';
                                                                return false;
                                                            }}
                                                            disabled={this.state.loading}>
                                                            <BackIcon />
                                                            <Typography variant="button" noWrap={true}>
                                                                {t('CANCEL_BOOKING.NEW_SEARCH_BUTTON')}
                                                            </Typography>
                                                        </Button>
                                                    )
                                            }
                                        </div>
                                    </Grid>
                                    {reservation !== null && reservation.state !== 'C' ? (
                                        <Grid item xs={6}>
                                            <div>
                                                <Button variant="raised"
                                                    color="secondary"
                                                    style={{ color: 'var(--primary-text-color)', backgroundColor: this.disableCancelButton() ? '#CECECE' : 'var(--error-color)' }}
                                                    onClick={this.handleCancelSubmit}
                                                    disabled={this.disableCancelButton()}>
                                                    <CancelIcon />
                                                    <Typography variant="button" noWrap={true}>
                                                        {t('CANCEL_BOOKING.CANCEL_BOOKING_BUTTON')}
                                                    </Typography>
                                                </Button>
                                            </div>
                                        </Grid>
                                    ) : ''}
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div >
        );
    }
}
export default translate('translations')(withStyles(styles)(ReservationCancelView));


// WEBPACK FOOTER //
// ./src/components/Reservation/ReservationCancelView.js